import toast from "react-hot-toast";
import { CLEAR_MESSAGE, SET_FAILED_MESSAGE, SET_FAILED_MESSAGE_TOAST, SET_SUCCESS_MESSAGE, SET_SUCCESS_MESSAGE_TOAST } from "../actions/types";
const initialState = {
  toastMessage: "",
  toastMessageType: false
};
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_SUCCESS_MESSAGE:
      return { toastMessage: payload, toastMessageType: true };
    case SET_FAILED_MESSAGE:
      return { toastMessage: payload, toastMessageType: false };
    case CLEAR_MESSAGE:
      return { toastMessage: "" };
    case SET_SUCCESS_MESSAGE_TOAST:
      toast.success(payload);
    case SET_FAILED_MESSAGE_TOAST:
      toast.error(payload);
    default:
      return state;
  }
}
